import { Translate } from 'next-translate';
import { z } from 'zod';

export const supportValidationSchema = (t: Translate) =>
  z.object({
    name: z
      .string()
      .min(2, { message: t('form.inputs.name.errors.min-length') })
      .max(50, { message: t('form.inputs.name.errors.max-length') }),
    email: z.string().email({ message: t('form.inputs.email.errors.invalid') }),
    message: z
      .string()
      .min(10, { message: t('form.inputs.message.errors.min-length') })
      .max(1000, { message: t('form.inputs.message.errors.max-length') }),
  });
